import { ENTRYPOINT } from "config/api";
import { downloadCSV, useListContext, type Identifier } from "react-admin";
import { BulkDeleteWithConfirmButton } from "react-admin";
import { HTTPError } from "shared/utils/error";
import LoadingButton from "./LoadingButton";
export interface QProps {
  filterValues?: any;
  sort?: any
  resource?: string;
  selectedIds?: Identifier[];
}

const BulkActionButtons = (props: QProps) => {
  const { sort } = useListContext()
  return (
    <>
      <BulkDeleteWithConfirmButton {...props} mutationMode="optimistic" />
      {props.resource === "patients" ? (
        <LoadingButton
          promise={() => dlExportCSV({ ...props, sort })}
        >
          Export CSV
        </LoadingButton>
      ) : null}
    </>
  );
};


export async function dlExportCSV(params: QProps) {
  const { filterValues, sort, selectedIds } = params;
  let sanitizedFilename = "patients"

  const searchParams = new URLSearchParams()
  if (selectedIds) {
    searchParams.append('selectedids', JSON.stringify(selectedIds))
    sanitizedFilename = sanitizedFilename.concat(`_select-${selectedIds.join('-')}`)
  }
  if (sort) {
    searchParams.append('sort', JSON.stringify(Object.values(sort)))
    sanitizedFilename = sanitizedFilename.concat(`_sort-${Object.values(sort).join('-')}`)
  }
  if (filterValues) {
    searchParams.append('filter', JSON.stringify(filterValues))
    const filterPart: string = Object.entries(filterValues)
      .map(([key, value]) => `${key}_${value}`.replace(/[^a-z0-9]/gi, "-"))
      .join("_");
    sanitizedFilename = sanitizedFilename.concat(`_filter-${filterPart}`)
  }
  const localDate = new Date()
    .toISOString()
    .replace(/[^0-9]/gi, "-")
    .slice(0, -2);
  sanitizedFilename = sanitizedFilename.concat('_', localDate)

  const csv = await fetch(
    `${ENTRYPOINT}/export-csv?${searchParams.toString()}`,
    {
      credentials: 'include', referrer: window.location.href,
    }
  ).then(res => {
    if (!res.ok) throw new HTTPError(res.status)
    return res.text()
  })

  await new Promise<void>((resolve) => {
    downloadCSV(csv, sanitizedFilename)
    resolve()
  })
}

export default BulkActionButtons;
